const addAttributesOption = () => {
  const catTitleInnerArr = document.querySelectorAll('.cpb-category-title__inner');

  catTitleInnerArr.forEach(el => {
    if (el.dataset.processed == 'true') return
    const srOnlyElem = document.createElement('span');
    srOnlyElem.classList.add('sr-only');
    srOnlyElem.textContent = 'select';

    el.children[0].prepend(srOnlyElem);

    el.tabIndex = '0';

    el.dataset.processed = true;
  })

  // Removing the alt attribute to avoid double spelling choice labels
  const imgTooltips = document.querySelectorAll('.cpb-option-tooltip-img');
  imgTooltips.forEach(el => {
    el.alt = '';
  })
}

const addAttributesQtyBtns = () => {
  const qtyBtns = document.querySelectorAll('.cpb-quantity-button');
  qtyBtns.forEach(btn => {
    if (btn.classList.contains('cpb-quantity-button-increase')) btn.ariaLabel = 'Increase quantity'
    if (btn.classList.contains('cpb-quantity-button-decrease')) btn.ariaLabel = 'Decrease quantity'
  })
}

const selectOptionByTapingEnter = () => {
  document.addEventListener('keydown', (e) => {
    if (e.key == 'Enter' && document.activeElement.closest('.cpb-option')) {
        document.activeElement.click();
    }
  })
}

const init = () => {
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
    setTimeout(() => {
      addAttributesOption();
    }, 800);
  });
  
  addAttributesQtyBtns();
}

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init)
selectOptionByTapingEnter();
